import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useIntl } from 'react-intl';
import { commonMessages } from 'utils/commonMessages';

type WhyNoServiceCallDialogProps = {
  isOpen: boolean,
  onClose: () => void,
}

export const WhyNoServiceCallDialog: React.FC<WhyNoServiceCallDialogProps> = (props: WhyNoServiceCallDialogProps) => {
  const { formatMessage } = useIntl();

  return(
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
    >
      <DialogTitle>{formatMessage({ id: 'WhyNoServiceCallDialog.Title', defaultMessage: 'Service call not found' })}</DialogTitle>
      <DialogContent>
        <DialogContentText color='text.primary'>{formatMessage({ id: 'WhyNoServiceCallDialog.Description', defaultMessage: 'We don\'t have information for the service call you entered due to one of the following reasons.' })}</DialogContentText>
        <DialogContentText>
          <ul>
            <li>{formatMessage({ id: 'WhyNoServiceCallDialog.Reason1', defaultMessage: 'The number you entered is incorrect. Please review it and try again.' })}</li>
            <li>{formatMessage({ id: 'WhyNoServiceCallDialog.Reason2', defaultMessage: 'The service call as not yet been processed. Please wait atleast 24 hours.' })}</li>
            <li>{formatMessage({ id: 'WhyNoServiceCallDialog.Reason3', defaultMessage: 'The service call has been created prior and is too old' })}</li>
          </ul>
        </DialogContentText>
        <DialogContentText color='text.primary'>{formatMessage({ id: 'WhyNoServiceCallDialog.Summary', defaultMessage: 'We are sorry for the inconvinience. If you believe that the information you have entered is correct, please contact us by phone' })}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} autoFocus>{formatMessage(commonMessages.close)}</Button>
      </DialogActions>
    </Dialog>
  );
};